import { useCallback } from 'react'

import { produce } from 'immer'

import { BulkTagsFieldValue } from '../types'

export function usePartialListManageProps(
  onChange: (values: BulkTagsFieldValue) => void,
  value: BulkTagsFieldValue,
) {
  const onAddTag = useCallback(
    (tagName: string) => {
      const updatedFieldValue = produce(value, draft => {
        draft.tags[tagName] = {
          name: tagName,
          status: 'exact',
        }
      })

      onChange(updatedFieldValue)
    },
    [onChange, value],
  )

  const onDeleteTag = useCallback(
    (tagName: string) => {
      const updatedFieldValue = produce(value, draft => {
        draft.tags[tagName] = {
          name: tagName,
          status: 'deleted',
        }
      })

      onChange(updatedFieldValue)
    },
    [onChange, value],
  )

  return {
    onAddTag,
    onDeleteTag,
  }
}
